import { useTranslation } from "react-i18next";

/**
 * apps/web :: components/dashboard :: EmptyStateCdlPrompt
 *
 * Small card shown below the rule-diff panel when the learner flagged CDL
 * interest during onboarding. Static copy: "CDL content isn't ready; we'll
 * email you". No CTA, no functionality — the expectation is email follow-up
 * via the ADR-0008 notification stack once the CDL corpus is ready.
 *
 * Renders nothing when `cdlInterest=false` so the parent can drop the card
 * in unconditionally.
 */
export interface EmptyStateCdlPromptProps {
  cdlInterest: boolean;
}

export default function EmptyStateCdlPrompt({
  cdlInterest,
}: EmptyStateCdlPromptProps) {
  const { t } = useTranslation();

  if (!cdlInterest) return null;

  return (
    <aside
      data-testid="dashboard-cdl-prompt"
      className="mt-lg rounded-lg border border-brand-accent/40 bg-brand-accent/5 p-md sm:p-lg"
    >
      <h3 className="font-display text-base font-bold text-brand-primary">
        {t("dashboard.cdlPrompt.heading")}
      </h3>
      <p className="mt-xs text-sm text-neutral-700">
        {t("dashboard.cdlPrompt.body")}
      </p>
    </aside>
  );
}
